import {
  EStatus,
  IHouseOfferHistoryV4Schema,
} from '../../../repositories/valuation-offer-history/entities/offer_history/HouseOfferHistoryV4Schema';
import { IOffersHistoryListingData } from '../../../store/offerHistory';

export const prepareOffers = (offers: IHouseOfferHistoryV4Schema[]): IOffersHistoryListingData['offers'] => {
  return offers.map(offer => ({
    ...offer,
    isDeactivated: offer.status === EStatus.Deactivated,
    dateEnd: offer.status === EStatus.Published ? 'В продаже' : offer.dateEnd || '–',
    expositionFull: `${offer.exposition} на Циан`,
  }));
};
